import { motion } from "framer-motion";

const STORY_IMG =
    "https://customer-assets.emergentagent.com/job_caribbean-premium/artifacts/algcp3ha_04DCB600-D055-49ED-AC04-941FD249AA1D.PNG";

export default function BrandStory() {
    return (
        <section
            id="story"
            data-testid="brand-story-section"
            className="relative empire-section bg-charcoal overflow-hidden"
            aria-label="Our Story"
        >
            <div className="empire-container">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    {/* Left: text */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        className="lg:col-span-7 lg:sticky lg:top-32"
                    >
                        <p className="empire-eyebrow">Our Story</p>
                        <h2
                            data-testid="brand-story-heading"
                            className="mt-6 font-serif text-cream text-[2.2rem] md:text-[3.4rem] lg:text-[4rem] leading-[1.04] tracking-[-0.01em]"
                        >
                            We cook the way our<br />
                            grandmothers cooked —<br />
                            <span className="italic text-gold">with the whole heart.</span>
                        </h2>

                        <div className="mt-10 space-y-6 max-w-xl text-cream/75 font-light text-[15px] md:text-[16px] leading-[1.8]">
                            <p>
                                Empire was born in the kitchens of Kingston, Jamaica,
                                and raised here, on Main Street, in the Hudson
                                Valley. Every plate carries the rhythm of a Sunday
                                afternoon back home: pots simmering, music low,
                                family arriving without warning.
                            </p>
                            <p>
                                We&rsquo;re not a fast-food shop. We are a community
                                table. We take our time. We season with patience. We
                                serve our neighbors the food we serve our family, and
                                we treat them like family when they walk in.
                            </p>
                            <p>
                                That&rsquo;s what Caribbean hospitality means to us.
                                That&rsquo;s what we bring to your wedding, your
                                boardroom, your birthday, and your Tuesday night.
                            </p>
                        </div>

                        <div className="mt-12 inline-flex items-center gap-5">
                            <span className="font-serif italic text-gold text-2xl">
                                — Michelle, Chef &amp; Founder
                            </span>
                            <span className="h-px w-12 bg-cream/30" />
                            <span className="empire-eyebrow !text-cream/55">
                                Empire Jamaica Fusion
                            </span>
                        </div>
                    </motion.div>

                    {/* Right: ribbon-cutting image (~+12% wider on lg, overflowing into the gap) */}
                    <div className="lg:col-span-5 relative">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
                            className="relative aspect-[4/5] overflow-hidden lg:w-[112%] lg:-ml-[6%]"
                        >
                            <img
                                src={STORY_IMG}
                                alt="Empire Jamaica Fusion ribbon-cutting ceremony at 385 Main Street, Poughkeepsie — Michelle Gibson with team and community members"
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover"
                                style={{ filter: "contrast(1.06) saturate(1.04) brightness(0.97)" }}
                            />
                            {/* Editorial finish: soft top vignette, gentle warm tint at bottom */}
                            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 via-transparent to-charcoal/15" />
                            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_60%,rgba(212,175,55,0.05),rgba(0,0,0,0)_60%)]" />
                            <div className="absolute -inset-px border border-gold/15 pointer-events-none" />
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
}
